import React from 'react';
import { Layout } from 'antd';
import { Menu } from '..';

const { Header } = Layout;
const App = () => (
	<Header style={{ width: '100%', zIndex: '10', justifyContent: 'space-between', boxShadow: '0 1px 15px 1px rgba(69,65,78,.1)' }}>
		<div className="logo">
			<img src="/assets/images/logo.png" alt="parter-portal" style={{ maxWidth: '100%', objectFit: 'cover', height: '35px' }} />
		</div>
		<Menu />
	</Header>
);

export default App;